import classNames from 'classnames';
import React, { CSSProperties, ReactElement, useEffect, useState } from 'react';

import { IDestructor } from '../../shared/types/IDestructor';
import { IParentProps } from '../../shared/types/IParentProps';
import { IQATestableProps } from '../../shared/types/IQATestableProps';
import { ISetState } from '../../shared/types/ISetState';
import { IStyleableProps } from '../../shared/types/IStyleableProps';

import styles from './Content.module.css';

export type IContentProps = IParentProps & IQATestableProps & IStyleableProps & {
    flex?: boolean;
};

export function OzContent (props: IContentProps): ReactElement {
    const {
        className = '',
        'data-testid': dataTestId,
        children,
        flex = false,
    }: IContentProps = props;

    const [vw, setVw]: [string, ISetState<string>] = useState('1vw');

    useEffect((): IDestructor => {
        function calculateViewWidth (): void {
            const vw: number = Math.min(document.documentElement.clientWidth, 1664) / 100;

            setVw(`${vw}px`);
        }

        function handleResize (): void {
            calculateViewWidth();
        }

        calculateViewWidth();

        window.addEventListener('resize', handleResize);

        return (): void => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const hostClassNames: string = classNames({
        [className]: !!className,
        [styles.host]: true,
        [styles.flex]: !!flex,
    });

    return (
        <div
            className={`${hostClassNames} mx-auto flex flex-wrap`}
            data-testid={dataTestId}
            style={{
                '--vw': vw,
            } as CSSProperties}
        >
            {children}
        </div>
    );
}
